import styled from 'styled-components';
import { CommonButton } from '../common/CommonButton';

export const WaringModal = ({
  visible = false,
  close,
}: {
  visible?: boolean;
  close?: () => void;
}) => {
  return (
    <ModalWrap $visible={visible}>
      <Dim />
      <ModalContent $visible={visible}>
        <Title>유의사항 </Title>
        <Content>
          <Inner>
            <ContentListItem>
              새틀라이트는 반드시 본인명의 계정으로 참가를 진행해야 합니다.
            </ContentListItem>
            <ContentListItem>
              각 새틀라이트는
              <strong>시작 5분 전부터 입장</strong> 가능합니다.
            </ContentListItem>
            <ContentListItem>
              새틀라이트는 입장 마감 전이라면 리엔트리를 할 수 있습니다.
            </ContentListItem>
            <ContentListItem>
              <strong>중도 포기 시 참가비는 환불되지 않습니다.</strong>
            </ContentListItem>
            <ContentListItem>
              <strong>인더머니를 달성하여 획득한 참가권은 티켓함으로 지급</strong>
              됩니다.
            </ContentListItem>
            <ContentListItem>참가권을 획득한 경우에도 추가로 획득할 수 있습니다.</ContentListItem>
            <ContentListItem>
              본 새틀라이트는 내부 사정에 따라 통보 없이 변경 또는 종료될 수 있으며{` `}
              <span>부적절한 방법으로 참여 시 운영자에 의해 제재</span>될 수 있습니다.
            </ContentListItem>
          </Inner>
        </Content>
        <ButtonContainer onClick={close}>
          <CommonButton text="확인" />
        </ButtonContainer>
      </ModalContent>
    </ModalWrap>
  );
};

const ButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;

  button {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  max-width: 90%;
  background: #302e2d;
  box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.2) inset;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px;
  border-radius: 20px 20px 0px 0px;
  padding: 25px 15px 15px 15px;
  padding-bottom: 0;
  overflow-y: auto;
  height: 380px;

  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`;

const Content = styled.ul`
  border-radius: 8px;
  background: #201f1e;
  padding: 20px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 240px;
  overflow-y: auto;
`;

const Inner = styled.div`
  margin-bottom: 30px;
`;

const ContentListItem = styled.li`
  color: #b2b2b2;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.39px;
  margin-bottom: 5px;
  position: relative;
  padding-left: 10px;

  strong {
    color: #ffffff99;
  }

  &:after {
    content: '';
    width: 3px;
    height: 3px;
    position: absolute;
    background-color: #b2b2b2;
    top: 8px;
    left: 0;
    border-radius: 50%;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const Title = styled.h3`
  color: #fbf6d5;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
`;
